/* jshint node:true */
'use strict';

var createStore = require('fluxible/addons').createStore;
var PersistentStateMixin    = require('../mixins/PersistentStateMixin');
var browser = require('../helpers/utils/browser.js');
var moment = require('moment');
var GameStrip = require('../helpers/GameStrip');

var ScoreboardStore = createStore({

    storeName: 'ScoreboardStore',

    mixins: [PersistentStateMixin],

    initialize: function() {
        this.data = {
            leagues : [],
            aggregated : false,
            formattedDates : []
        };
        this._cache = {};
    },

    handlers: {
        RECEIVED_SCOREBOARD: function(payload) {
            var self = this;
            var scores;

            self.data = {
                leagues : []
            };
            self._cache = {};

            payload = payload || {leagues:[{}], events:[]};

            if(payload && payload.scores){
                scores = payload.scores;
                self.data.aggregated = true;
            }else{
                scores = [payload];
                self.data.aggregated = false;
            }

            scores.map(function(score, i){
                var id = score.leagues[0].id;
                if(!self._cache[id]){
                    var leagueScores = {
                        events : [],
                        name : score.leagues[0].name,
                        calendar : score.leagues[0].calendar
                    };
                    score.events.map(function(event, j){
                        leagueScores.events.push(new GameStrip({
                            sport : payload.sport,
                            event : event
                        }));
                    });
                    self.data.leagues.push(leagueScores);
                    self.data.formattedDates = self.getCalendar();
                    self._cache[id] = 1;
                }
            });
            this.emitChange();
        }
    },
    getScoreboard: function() {
        try {
            return this.data || {};
        } catch (e) {
            return {};
        }
    },
    getCalendar: function() {
        var dates = [];
        var calendar = [];

        this.data.leagues.map(function(league, i){
            calendar = calendar.concat(league.calendar);
        });

        calendar.map(function(date, i){
            dates.push(new Date(date).setHours(0,0,0,0));
        });

        return dates;
    }
});

module.exports = ScoreboardStore;



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/stores/ScoreboardStore.js
 **/